export const column = [
    {
        label: '序号',
        prop: 'sortNum'
    },
    {
        label: '单位名称',
        prop: 'unitName'
    },
    {
        label: '联系人姓名',
        prop: 'contactsName'
    },
    {
        label: '联系人手机号',
        prop: 'contactsPhone'
    },
    {
        label: '合作意愿',
        prop: 'cooperateDesire'
    },
    {
        width: 120,
        label: '留言时间',
        prop: 'insertDate'
    },
    {
        label: '备注',
        prop: 'remarks'
    },
]

export const intendList = [
    {
        label: '全媒体运营师培训+考核',
        value: '1'
    },
    {
        label: '网络视听主播培训+考核',
        value: '2'
    },
    {
        label: '其他',
        value: '3'
    }
]